import { render } from "./CollaborationPlans.vue?vue&type=template&id=07a97eae"
import script from "./CollaborationPlans.vue?vue&type=script&lang=js"
export * from "./CollaborationPlans.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__